export enum DomainIntegrationProvider {
    SLACK = 'slack',
    SHOPIFY = 'shopify',
    AMPLY = 'amply',
}
